import { render, staticRenderFns } from "./InsightPresetConfig.vue?vue&type=template&id=209ad8d2&"
import script from "./InsightPresetConfig.vue?vue&type=script&lang=ts&"
export * from "./InsightPresetConfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports